import { render, staticRenderFns } from "./PlatformDoughnutChart.vue?vue&type=template&id=5972771c&scoped=true&"
import script from "./PlatformDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./PlatformDoughnutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5972771c",
  null
  
)

export default component.exports